module.exports = __webpack_public_path__ + "img/bz3.ae4380d4.png";